import React from 'react';
import '../../styles/navbar.css';
import { connect } from 'react-redux';
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi';
import { AiOutlineHome, AiOutlinePhone } from 'react-icons/ai';
import { MdOutlinePrivacyTip } from 'react-icons/md';
import { BiSpreadsheet } from 'react-icons/bi';


function SideBar(state) {

    const { collapseSidebar, toggleSidebar, collapsed, toggled, broken, rtl } = useProSidebar();

    return (
        <div className="sidebar">
            <Sidebar
            backgroundColor="#66BFBF"
            rtl={false}
            style={{ height: "100%" }}
            defaultCollapsed={true}
            >
            <Menu
            menuItemStyles={{
                button: ({ level, active, disabled }) => {
                    // only apply styles on first level elements of the tree
                    if (level === 0)
                    return {
                        backgroundColor: active ? '#f3f3f3' : undefined,
                    };
                }
            }}>
            <MenuItem
                    icon={<GiHamburgerMenu />}
                    onClick={() => {
                    collapseSidebar();
                    }}
                    style={{ textAlign: "center" }}
                ></MenuItem>
                <MenuItem onClick={() => {
                    toggleSidebar();
                    }} active={window.location.pathname === "/dashboard"} component={<Link to="/dashboard" />} icon ={<AiOutlineHome/>}> Dashboard</MenuItem>
                <MenuItem onClick={() => {
                    toggleSidebar();
                    }} active={window.location.pathname === "/privacy-requests"} component={<Link to="/privacy-requests" />} icon ={<MdOutlinePrivacyTip/>}> Privacy Requests</MenuItem>
                <MenuItem onClick={() => {
                    toggleSidebar();
                    }} active={window.location.pathname === "/ringba"} component={<Link to="/ringba" />} icon ={<AiOutlinePhone/>}> Ringba Manager</MenuItem>
                <MenuItem onClick={() => {
                    toggleSidebar();
                    }} active={window.location.pathname === "/pixel-log"} component={<Link to="/pixel-log" />} icon ={<BiSpreadsheet/>}> Pixel Log</MenuItem>
                
            </Menu>
            </Sidebar>
        
      </div>
    );
};

const mapStateToProps = function(state) {
    return {
        user: state.userReducer.user,
        isLoggedIn: state.userReducer.isLoggedIn
    }
}
  
  
  export default connect(mapStateToProps)(SideBar);